import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";
import { downloadCSV, getPageSize, trans } from "utils/helpers";
import {
  deleteDataCollection,
  getDataCollection,
  postDataCollection,
  postDataCollectionById,
} from "./api";
import { DataCollectionPropertiesForm } from "./DataCollectionPropertiesForm";
import { MessageType } from "types/enum";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { ExportDynamicForm } from "../../api";
import { ImportForm } from "../ImportForm";

interface DataCollectionPropsType {
  onHide: (e: boolean) => void;

  mode: "create" | "view" | "edit";
  setChanged?: any;
}

export const DataCollectionForm = ({
  onHide,

  mode,
  setChanged,
}: DataCollectionPropsType) => {
  const [userChanges, setUserChanges] = useState({});
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [response, setResponse] = useState<any>([]);
  const [selectedObj, setSelectedObj] = useState<string | any>(null);
  const [showPropertiesForm, setShowPropertiesForm] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const [detailById, setDetailById] = useState<any>("");
      const [pageNum, setPageNum] = useState<number>(1);
      const [pageSize, setPageSize] = useState<number>(25);
      const [pages, setPages] = useState<number>(0);

  const [detailMode, setDetailMode] = useState<"create" | "view" | "edit">();
  const [search, setsearch] = useState<any>("");
  const [selectList , setSelectList] = useState<any>([])
  const [resetMultiSelect , setResetMultiSelect] = useState<any>(false)
const [showImportForm,setShowImportForm]=useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault();
    let data = {
      Title: event.target.Title?.value,
      TitleEN: event.target.TitleEN?.value,
      SystemKey: event.target.SystemKey?.value,
      Description: event.target.Description?.value,
      DescriptionEN: event.target.DescriptionEN?.value,
      CodeLength: +event.target.CodeLength?.value,
      BindCodeInDescription:event.target.BindCodeInDescription?.checked
    };
    try {
      if (detailMode === "create") {
        await postDataCollection(data, "post");
      } else {
        await postDataCollection(
          {
            ...data,
            ActivityStatus: +event.target.ActivityStatus?.value,
            Id: selectedObj.Id,
          },
          "put"
        );
      }
      setForceUpdate(!forceUpdate);
      setShowForm(false);
      setChanged(true);
    } catch (error) {}
  };
    const handleImport = async() => {  
         
setShowImportForm(true)
    }
  const getDataCollectionByIdAsync = async () => {
    try {
      const response = await postDataCollectionById(selectedObj.Id);
      setDetailById(response.Data);
    } catch (error) {}
  };
  const handleExportAsync = async () => {
    console.log({selectList});
    let SystemKeyList = selectList.map(item=>{ return item.SystemKey})
    try {
      const respons =   await ExportDynamicForm(SystemKeyList,null)
      const contentDisposition = respons.headers['file-name'];   
      let fileName = 'downloaded-file'; // Default filename
      if (contentDisposition) {
              fileName = contentDisposition.split('.')[0]
          }
          var pom = document.createElement('a');
          pom.setAttribute('href', window.URL.createObjectURL(respons.data));
          pom.setAttribute('download', fileName);
          pom.click();
          setSelectList([])
          setResetMultiSelect(!resetMultiSelect)
    } catch (error) {}
  };

  const getDataCollectionAsync = async (pagNum = pageNum) => {
    setLoading(false);
      let pageSizeChangedByUser = getPageSize("dataCollection")
        setPageSize(pageSizeChangedByUser)
    try {
      const res = await getDataCollection(pagNum, pageSizeChangedByUser);
      if (res.Data.TotalRecords > 0) {
        setResponse(res.Data);
        setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;

      }
    } catch (error) {}
    setLoading(true);
  };




  const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("dataCollection", e.currentTarget.value)
        getDataCollectionAsync(1);
    };
    const handleGoPage = (value) => {
        if (value) {
            setPageNum(+value);
            getDataCollectionAsync(+value);
        } else {
        }
    };
    const handleNextPage = () => {
        if (response.TotalRecords && ((response.TotalRecords / pageSize) > pageNum)) {
            setPageNum((pageNum) => { return +pageNum + 1 });
            getDataCollectionAsync(pageNum + 1);

        }
    };
    const handlePrevPage = () => {
        if (pageNum > 1) {
            setPageNum((pageNum) => { return +pageNum - 1 });
            getDataCollectionAsync(pageNum - 1);
        }
    };

  

  const handleDeleteRow = async () => {
    try {
      const res = await deleteDataCollection(selectedObj.Id);
      setForceUpdate(!forceUpdate);
      setChanged(true);
    } catch (error) {}
  };

  function cancel() {
    setShowForm(false);
  }

  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
    setShowForm(false);
  };

  const clickToolbarCallback = (clickedButtonName: string) => {
    console.log("ss" ,clickedButtonName.toLowerCase() ,selectList )
    switch (clickedButtonName.toLowerCase()) {
      case "excel":
        downloadCSV(response.Data, 1, trans("dataCollection"));
        break;
      case "refresh":
        setForceUpdate(!forceUpdate);
        break;
      case "create":
        setShowForm(true);
        setDetailMode("create");
        break;
      case "remove":
        if (selectedObj?.Id)
          // Toast(
          //   trans("msg_deleteconfirm"),
          //   "warning",
          //   "alert",
          //   handleDeleteRow
          // );
          Toast(
            trans("msg_deleteconfirm"),
            MessageType.confirmDelete,
            handleDeleteRow
          );
        break;
      case "view":
        if (selectedObj?.Id) {
          setShowForm(true);
          setDetailMode("view");
          getDataCollectionByIdAsync();
        }
        break;
      case "values":
        if (selectedObj?.Id) setShowPropertiesForm(true);
        break;
      case "export":
        if (selectList.length>0) handleExportAsync();
        break;
      case "import":
        handleImport();
        break;
      case "edit":
        if (selectedObj?.Id) {
          setShowForm(true);
          getDataCollectionByIdAsync();
          setDetailMode("edit");
        }
        break;
    }
  };
    const selectListCallBack =(list)=>{
          
        setSelectList(list[1])
      }
  useEffect(() => {
    getDataCollectionAsync();
  }, [forceUpdate]);

  return (
    <>
       {
            showImportForm &&
            <ModalForm modalHeight={80} modalProfileKey={"Users"} title={"import"} onHide={() => setShowImportForm(false)} show={showImportForm}>
              <ImportForm reload={()=>{ setShowImportForm(false) ;setForceUpdate(!forceUpdate) }}  showForm={() => { setShowImportForm(false) }} />
            </ModalForm>
          }
      {showPropertiesForm && (
        <ModalForm
          title={trans("viewForm") + " " + trans("values")}
          show={showPropertiesForm}
          onHide={() => {
            setShowPropertiesForm(false);
          }}
        >
          <DataCollectionPropertiesForm
            selectedRow={selectedObj}
            mode="create"
            onHide={onHide}
          />
        </ModalForm>
      )}
      <Toolbar
       helpBtn={false}
        Print={false}
        values={true}
        id={selectedObj?.Id}
        emptyList={response?.TotalRecords == 0 || response?.Data == null}
        remove={true}
        create={true}
        Export={true}
        view={true}
        edit={true}
        Importprocesses={true}
        handleClickToolbar={clickToolbarCallback}
  
      />

      {showForm && (
        <div className="card">
        <form
          className="TypeSettingForm row card-body "
          onSubmit={handleSubmit}
        >
          <div className="col-md-4 col-sm-12">
            <Textbox
              Change={(e) => {
                setUserChanges({ ...userChanges, ...e });
              }}
              required={true}
              textboxName={"Title"}
              textboxType="text"
              resetForm={resetForm}
              labelText={"Title"}
              mode={detailMode}
              defaultValue={detailMode !== "create" ? detailById.Title : ""}
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <Textbox
              Change={(e) => {
                setUserChanges({ ...userChanges, ...e });
              }}
              textboxName={"TitleEN"}
              textboxType="text"
              resetForm={resetForm}
              labelText={"TitleEN"}
              mode={detailMode}
              defaultValue={detailMode !== "create" ? detailById.TitleEN : ""}
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <Textbox
              Change={(e) => {
                setUserChanges({ ...userChanges, ...e });
              }}
              required={true}
              textboxName={"SystemKey"}
              textboxType="systemKey"
              resetForm={resetForm}
              labelText={"SystemKey"}
              mode={detailMode}
              defaultValue={detailMode !== "create" ? detailById.SystemKey : ""}
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <Textbox
              Change={(e) => {
                setUserChanges({ ...userChanges, ...e });
              }}
              required={true}
              textboxName={"CodeLength"}
              textboxType="number"
              resetForm={resetForm}
              labelText={"CodeLength"}
              mode={detailMode}
              min={1}
              defaultValue={
                detailMode !== "create" ? detailById.CodeLength : ""
              }
            />
          </div>

          {detailMode != "create" && (
            <div className="col-md-4 mt-1">
              <EnumerationTypeSelect
                value={detailById?.ActivityStatus}
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                name="ActivityStatus"
                enumTypeSelect="ActivityStatus"
                mode={detailMode}
                label="Status"
              />
            </div>
          )}
          <div className="col-md-4 col-sm-12">
            <Textbox
              Change={(e) => {
                setUserChanges({ ...userChanges, ...e });
              }}
              textboxName={"Description"}
              textboxType="textarea"
              resetForm={resetForm}
              labelText={"Description"}
              mode={detailMode}
              defaultValue={
                detailMode !== "create" ? detailById.Description : ""
              }
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <Textbox
              Change={(e) => {
                setUserChanges({ ...userChanges, ...e });
              }}
              textboxName={"DescriptionEN"}
              textboxType="textarea"
              resetForm={resetForm}
              labelText={"DescriptionEN"}
              mode={detailMode}
              defaultValue={
                detailMode !== "create" ? detailById.DescriptionEN : ""
              }
            />
          </div>
          <div className="col-12">
            <CheckableButton
              defaultChecked={detailById?.BindCodeInDescription}
              defaultValue={detailById?.BindCodeInDescription}
              labelText={"BindCodeInDescription"}
              inputName={"BindCodeInDescription"}
              type="checkbox"
            />
          </div>
          {mode != "view" ? (
            <div className="col-lg-12 mt-1 btns_form">
              <Button value="Save" btnType="submit" />
              <Button
                btnType="cancel"
                value="Cancel"
                onClick={() => {
                  cancel();
                }}
              />
            </div>
          ) : (
            <div className="col-lg-12 mt-1 btns_form">
              <Button
                btnType="primary"
                value="close"
                onClick={() => {
                  cancel();
                }}
              />
            </div>
          )}
        </form>
        </div>
      )}

      {loading ? (
        <>
          {response?.Data?.length > 0 ? (
            <div className="card">
              <div className="card-body p-0">
                <>
                  <DataGrid
                    multiSelect={true}
                    selectList={selectListCallBack}
                    resetMultiSelect={resetMultiSelect}
                    DoubleClick={(obj) => {
                      setSelectedObj(obj);
                      // clickToolbarCallback("view");
                    }}
                    View={true}
                    ViewParametr={"NotSeen"}
                    // handlefiltering={(str: any) => {
                    //   str.Filterlist != undefined
                    //     ? setFilterAndSort(str)
                    //     : setFilterAndSort({
                    //         ...filterAndSort,
                    //         Filterlist: str,
                    //       });
                    // }}
                    // filterStr={filterAndSort.Filterlist}
                    // orderFormatList={filterAndSort.OrderFormat}
                    // orderFormat={(order) => {
                    //   setFilterAndSort({
                    //     ...filterAndSort,
                    //     OrderFormat: order,
                    //   });
                    // }}
                    handleDelete={handleDeleteRow}
                    parentName={"dataCollection"}
                    theadData={Object.keys(response.Data[0])}
                    tbodyData={response.Data}
                    minCellWidth={80}
                    selectedRowObjectCallback={selectedObjCallback}
                    rowSelected={selectedObj}
                    startIndex={1}
                    totalRecords={response.TotalRecords}
                    pageNum={pageNum}
                    pageSize={pageSize}
                    HandleNextPage={handleNextPage}
                    HandlePrevPage={handlePrevPage}
                    handlechangePageSize={handleChangePageSize}
                    first={() => { getDataCollectionAsync(pages); setPageNum(pages) }}
                    end={() => { getDataCollectionAsync(1); setPageNum(1) }}
                    handleGoPage={handleGoPage}
                  />
                </>
              </div>
            </div>
          ) : (
            <Message message={"NoDataForPreview"} type={messageType} />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};
